var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyArtifact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2014 0.0666504H31C34.8292 0.0666504 37.9333 3.17081 37.9333 6.99998V39C37.9333 42.8292 34.8292 45.9333 31 45.9333H6.99998C3.17081 45.9333 0.0666504 42.8292 0.0666504 39V14.7024L15.2014 0.0666504ZM16.4956 3.26665L3.26665 16.0594V39C3.26665 41.0619 4.93812 42.7333 6.99998 42.7333H31C33.0618 42.7333 34.7333 41.0618 34.7333 39V6.99998C34.7333 4.93812 33.0619 3.26665 31 3.26665H16.4956Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8485 0.0666504C16.7321 0.0666504 17.4485 0.782995 17.4485 1.66665V10.0476C17.4485 13.8768 14.3443 16.9809 10.5151 16.9809H1.66665C0.782995 16.9809 0.0666504 16.2646 0.0666504 15.3809C0.0666504 14.4973 0.782995 13.7809 1.66665 13.7809H10.5151C12.577 13.7809 14.2485 12.1095 14.2485 10.0476V1.66665C14.2485 0.782995 14.9648 0.0666504 15.8485 0.0666504Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0979 24.5238C11.0979 23.6402 11.8142 22.9238 12.6979 22.9238H25.304C26.1876 22.9238 26.904 23.6402 26.904 24.5238C26.904 25.4075 26.1876 26.1238 25.304 26.1238H12.6979C11.8142 26.1238 11.0979 25.4075 11.0979 24.5238Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0979 31.7619C11.0979 30.8782 11.8142 30.1619 12.6979 30.1619H25.304C26.1876 30.1619 26.904 30.8782 26.904 31.7619C26.904 32.6455 26.1876 33.3619 25.304 33.3619H12.6979C11.8142 33.3619 11.0979 32.6455 11.0979 31.7619Z",
    fill: "#B3B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyArtifact);
export default __webpack_public_path__ + "static/media/empty-artifact.36a5930911c9539b382d413670e1e781.svg";
export { ForwardRef as ReactComponent };